import { MANAGERS_WITH_CMNTY } from '../../../../User/Roles';

export default ({ user }) => MANAGERS_WITH_CMNTY.includes(user.role.type);
